<template>
    <header :class="headerClass">
        <h1 :class="headingClass">
            <span>{{ heading }}</span>
            <slot name="heading"></slot>
        </h1>

        <div v-if="content || $slots.content" :class="contentClass">
            <span>{{ content }}</span>
            <slot name="content"></slot>
        </div>
    </header>
</template>

<script>
    export default {
        props: {
            heading: { type: String, required: true },
            content: { type: String, default: '' },
            isCenter: { type: Boolean, default: false },
            size: { type: String, default: undefined },
            contentSpacing: { type: String, default: undefined },
        },

        computed: {
            headerClass() {
                return {
                    'page-header': true,
                    'page-header--is-center': this.isCenter,
                    [`page-header--size-${this.size}`]: this.size,
                    [`page-header--spacing-${this.contentSpacing}`]: this.contentSpacing,
                }
            },
            headingClass() {
                return {
                    'page-header__heading': true,
                    [`page-header--spacing-${this.contentSpacing}`]: this.contentSpacing,
                }
            },
            contentClass() {
                return {
                    'page-header__content': true,
                    'page-header--is-center': this.isCenter,
                }
            },
        },
    }
</script>
